// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"72d1255c","453":"2781f687","732":"39b4dd8f"}[chunkId] + ".chunk.js";
};